module.exports = __webpack_public_path__ + "cfd25431a151dbcd238e4fadc3e05cd8.png";